/*
 * Module for duplicate person/nonperson look up
*/

rs.module("ui/controls/duplicatepersonlookup",

    [],

    function () {

        var _jsSelectors;
        var _cssClasses;
        var _backendUrls;
        
        var _popup;

        var _onDuplicateSelectionCompleteHandler;
        var _getLookupParametersFunction;

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, backendUrls) {

            // unpack js selectors
            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _backendUrls = backendUrls;

            _popup = $.js(_jsSelectors.popup);

            // hookup lookup link click event
            $.js(_jsSelectors.lookupLink).click(_lookupDuplicates);

            // Exported instance API
            return {
                onGetLookupParameters,
                onDuplicateSelectionComplete
            };
        }

        //
        // API function to allow consumers to tell this module where to pull lookup parameters from
        //
        function onGetLookupParameters(getLookupParametersFunction) {
            _getLookupParametersFunction = getLookupParametersFunction;
        }

        //
        // API function to allow consumers to specify a call back function to execute after duplicate selection is complete
        // This call back will return a participant key (participantkey of the duplicate selected or -1 if it is a new person)
        //
        function onDuplicateSelectionComplete(onDuplicateSelectionComplete) {
            _onDuplicateSelectionCompleteHandler = onDuplicateSelectionComplete
        }

        //
        // Perform duplicate lookup
        //
        function _lookupDuplicates() {
            
            // get the parameters to perform the lookup
            var parameters = _getLookupParametersFunction.call();

            // only perform the lookup if the parameters object is not null
            if (parameters) {

                // Throw error if object returned from _getLookupParametersFunction doesn't have all necessary values
                if (!parameters.hasOwnProperty("isPerson") ||
                    !parameters.hasOwnProperty("nonPersonType") ||
                    !parameters.hasOwnProperty("tin") ||
                    !parameters.hasOwnProperty("firstName") ||
                    !parameters.hasOwnProperty("lastName") ||
                    !parameters.hasOwnProperty("nonPersonName")) {
                    throw "JSON object returned from onGetLookupParameters() requires properties: 'isPerson', 'nonPersonType', 'tin', 'firstName', 'lastName' and 'nonPersonName'.";
                }

                // Show spinner
                $.js(_jsSelectors.ajaxSpinner).show();

                // perform lookup
                $.get(_backendUrls.duplicateLookup,
                    {
                        isPerson: parameters.isPerson,
                        nonPersonType: parameters.nonPersonType,
                        tin: parameters.tin,
                        nonPersonName: parameters.nonPersonName,
                        firstName: parameters.firstName,
                        lastName: parameters.lastName
                    })
                    .done(function (result) {

                        if (result.noMatches) {
                            // since there were no matches, no need to show popup, just execute callback if it has been defined
                            if (_onDuplicateSelectionCompleteHandler) {
                                _onDuplicateSelectionCompleteHandler.call(_popup, -1);
                            }
                        }
                        else {
                            // display results inside the popup
                            _popup.js(_jsSelectors.lookupResults).html(result);

                            // widen the popup to show grid results
                            _popup.js(_jsSelectors.modalContent).addClass(_cssClasses.widePopup);

                            // show the popup 
                            _popup.modal("show");
                        }

                        // hide the spinner after lookup is complete
                        $.js(_jsSelectors.ajaxSpinner).hide();
                    });
            }
        }

        //
        // Initialize lookup results (called once _LookupResults.cshtml is rendered)
        //
        function initializeResults(jsSelectors, grid) {

            // listen for new person button clicks; call handler but send -1 for participantkey
            $.js(jsSelectors.newPersonButton, { required: false }).click(function () {
                if (_onDuplicateSelectionCompleteHandler) {
                    _onDuplicateSelectionCompleteHandler.call(_popup, -1);
                }
            });

            // Listen for grid row selection
            grid.selectionChanged(function (values, rows) {

                // need to make sure values is greater than zero because grid.selectionChanged fires when grid is first rendered
                if (values.length > 0) {

                    // call handler and send selected row's participantkey
                    if (_onDuplicateSelectionCompleteHandler) {
                        _onDuplicateSelectionCompleteHandler.call(_popup, values[0]);
                    }

                    _popup.modal("hide");
                }
            });
        }

        // Exported public API
        var exports = {
            initialize,
            initializeResults
        };

        return exports;
    }
);